export const PARTNER = `{
  id
  name
  display_name
  logo
}`
